import type { IconProps } from "../Icon.props";
import createWebIcon from "../createWebIcon";
import validateKeys from "../validateKeys";

export default function QRPlaceholder({
  outline,
  ...props
}: IconProps): JSX.Element {
  return outline ? (
    <QRPlaceholder.Outline {...props} />
  ) : (
    <QRPlaceholder.Solid {...props} />
  );
}

QRPlaceholder.Outline = function Outline({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Outline`,
    path: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 82 82" fill="none">
        <path
          d="M29.3142 33.0642C27.7616 33.136 26.4789 31.9026 26.4114 30.3343C26.4114 28.7627 27.6265 27.4643 29.1792 27.3926C30.6982 27.3926 31.9471 28.5918 31.9808 30.1259C32.0483 31.701 30.8332 32.9993 29.3142 33.0642Z"
          fill="currentColor"
        />
        <path
          d="M29.3142 45.5721C27.7616 45.6438 26.4789 44.4104 26.4114 42.8387C26.4114 41.2671 27.6265 39.9721 29.1792 39.9004C30.6982 39.9004 31.9471 41.0996 31.9808 42.6371C32.0483 44.2088 30.8332 45.5071 29.3142 45.5721Z"
          fill="currentColor"
        />
        <path
          d="M29.3142 58.0799C27.7616 58.1516 26.4789 56.9182 26.4114 55.3465C26.4114 53.7749 27.6265 52.48 29.1792 52.4082C30.6982 52.4082 31.9471 53.6075 31.9808 55.145C32.0483 56.7166 30.8332 58.015 29.3142 58.0799Z"
          fill="currentColor"
        />
        <path
          d="M41.7197 33.0642C40.167 33.136 38.8843 31.9026 38.8168 30.3343C38.8168 28.7627 40.032 27.4643 41.5847 27.3926C43.1036 27.3926 44.3525 28.5918 44.3863 30.1259C44.4538 31.701 43.2386 32.9993 41.7197 33.0642Z"
          fill="currentColor"
        />
        <path
          d="M41.7197 45.5721C40.167 45.6438 38.8843 44.4104 38.8168 42.8387C38.8168 41.2671 40.032 39.9721 41.5847 39.9004C43.1036 39.9004 44.3525 41.0996 44.3863 42.6371C44.4538 44.2088 43.2386 45.5071 41.7197 45.5721Z"
          fill="currentColor"
        />
        <path
          d="M41.7197 58.0799C40.167 58.1516 38.8843 56.9182 38.8168 55.3465C38.8168 53.7749 40.032 52.48 41.5847 52.4082C43.1036 52.4082 44.3525 53.6075 44.3863 55.145C44.4538 56.7166 43.2386 58.015 41.7197 58.0799Z"
          fill="currentColor"
        />
        <path
          d="M54.1251 33.0642C52.5725 33.136 51.2898 31.9026 51.2223 30.3343C51.2223 28.7627 52.4374 27.4643 53.9901 27.3926C55.5091 27.3926 56.758 28.5918 56.7917 30.1259C56.8592 31.701 55.6441 32.9993 54.1251 33.0642Z"
          fill="currentColor"
        />
        <path
          d="M54.1251 45.5721C52.5725 45.6438 51.2898 44.4104 51.2223 42.8387C51.2223 41.2671 52.4374 39.9721 53.9901 39.9004C55.5091 39.9004 56.758 41.0996 56.7917 42.6371C56.8592 44.2088 55.6441 45.5071 54.1251 45.5721Z"
          fill="currentColor"
        />
        <path
          d="M54.1251 58.0799C52.5725 58.1516 51.2898 56.9182 51.2223 55.3465C51.2223 53.7749 52.4374 52.48 53.9901 52.4082C55.5091 52.4082 56.758 53.6075 56.7917 55.145C56.8592 56.7166 55.6441 58.015 54.1251 58.0799Z"
          fill="currentColor"
        />
        <path
          opacity="0.4"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M29.397 10.25C30.832 10.25 31.9971 11.3925 31.9971 12.803C31.9971 14.2102 30.8354 15.3526 29.397 15.3526L23.8312 15.356C19.2119 15.3627 15.4536 19.0515 15.4536 23.5845V29.9369C15.4536 31.344 14.2851 32.4899 12.8501 32.4899C11.4151 32.4899 10.25 31.344 10.25 29.9369V23.5845C10.25 16.2405 16.3419 10.2601 23.8278 10.2534L29.3936 10.25H29.397ZM59.3472 10.25H53.9044C52.4694 10.25 51.3043 11.3925 51.3043 12.803C51.3043 14.2102 52.4694 15.3493 53.9044 15.3493H59.3472C63.9836 15.3493 67.7556 19.0481 67.7556 23.5946V29.9369C67.7556 31.344 68.9207 32.4899 70.3557 32.4899C71.7941 32.4899 72.9557 31.344 72.9557 29.9369V23.5946C72.9557 16.2338 66.8536 10.25 59.3472 10.25ZM29.3014 73.4917H23.8586C16.3522 73.4917 10.25 67.5079 10.25 60.1471L10.25 53.8048C10.25 52.3977 11.4117 51.2518 12.8501 51.2518C14.2851 51.2518 15.4502 52.3977 15.4502 53.8048L15.4502 60.1471C15.4502 64.6936 19.2222 68.3924 23.8586 68.3924H29.3014C30.7364 68.3924 31.9014 69.5315 31.9014 70.9387C31.9014 72.3492 30.7364 73.4917 29.3014 73.4917ZM53.8088 73.4917C52.3738 73.4917 51.2087 72.3492 51.2087 70.9387C51.2087 69.5315 52.3703 68.3891 53.8088 68.3891L59.3745 68.3857C63.9938 68.379 67.7522 64.6902 67.7522 60.1572L67.7522 53.8048C67.7522 52.3977 68.9207 51.2518 70.3557 51.2518C71.7907 51.2518 72.9558 52.3977 72.9558 53.8048V60.1572C72.9558 67.5012 66.8638 73.4816 59.3779 73.4883L53.8122 73.4917H53.8088Z"
          fill="currentColor"
        />
      </svg>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};

QRPlaceholder.Solid = function Solid({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Solid`,
    path: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 82 82" fill="none">
        <path
          d="M29.3142 33.0642C27.7616 33.136 26.4789 31.9026 26.4114 30.3343C26.4114 28.7627 27.6265 27.4643 29.1792 27.3926C30.6982 27.3926 31.9471 28.5918 31.9808 30.1259C32.0483 31.701 30.8332 32.9993 29.3142 33.0642Z"
          fill="currentColor"
          className="icon-primary"
        />
        <path
          d="M29.3142 45.5721C27.7616 45.6438 26.4789 44.4104 26.4114 42.8387C26.4114 41.2671 27.6265 39.9721 29.1792 39.9004C30.6982 39.9004 31.9471 41.0996 31.9808 42.6371C32.0483 44.2088 30.8332 45.5071 29.3142 45.5721Z"
          fill="currentColor"
          className="icon-primary"
        />
        <path
          d="M29.3142 58.0799C27.7616 58.1516 26.4789 56.9182 26.4114 55.3465C26.4114 53.7749 27.6265 52.48 29.1792 52.4082C30.6982 52.4082 31.9471 53.6075 31.9808 55.145C32.0483 56.7166 30.8332 58.015 29.3142 58.0799Z"
          fill="currentColor"
          className="icon-primary"
        />
        <path
          d="M41.7197 33.0642C40.167 33.136 38.8843 31.9026 38.8168 30.3343C38.8168 28.7627 40.032 27.4643 41.5847 27.3926C43.1036 27.3926 44.3525 28.5918 44.3863 30.1259C44.4538 31.701 43.2386 32.9993 41.7197 33.0642Z"
          fill="currentColor"
          className="icon-primary"
        />
        <path
          d="M41.7197 45.5721C40.167 45.6438 38.8843 44.4104 38.8168 42.8387C38.8168 41.2671 40.032 39.9721 41.5847 39.9004C43.1036 39.9004 44.3525 41.0996 44.3863 42.6371C44.4538 44.2088 43.2386 45.5071 41.7197 45.5721Z"
          fill="currentColor"
          className="icon-primary"
        />
        <path
          d="M41.7197 58.0799C40.167 58.1516 38.8843 56.9182 38.8168 55.3465C38.8168 53.7749 40.032 52.48 41.5847 52.4082C43.1036 52.4082 44.3525 53.6075 44.3863 55.145C44.4538 56.7166 43.2386 58.015 41.7197 58.0799Z"
          fill="currentColor"
          className="icon-primary"
        />
        <path
          d="M54.1251 33.0642C52.5725 33.136 51.2898 31.9026 51.2223 30.3343C51.2223 28.7627 52.4374 27.4643 53.9901 27.3926C55.5091 27.3926 56.758 28.5918 56.7917 30.1259C56.8592 31.701 55.6441 32.9993 54.1251 33.0642Z"
          fill="currentColor"
          className="icon-primary"
        />
        <path
          d="M54.1251 45.5721C52.5725 45.6438 51.2898 44.4104 51.2223 42.8387C51.2223 41.2671 52.4374 39.9721 53.9901 39.9004C55.5091 39.9004 56.758 41.0996 56.7917 42.6371C56.8592 44.2088 55.6441 45.5071 54.1251 45.5721Z"
          fill="currentColor"
          className="icon-primary"
        />
        <path
          d="M54.1251 58.0799C52.5725 58.1516 51.2898 56.9182 51.2223 55.3465C51.2223 53.7749 52.4374 52.48 53.9901 52.4082C55.5091 52.4082 56.758 53.6075 56.7917 55.145C56.8592 56.7166 55.6441 58.015 54.1251 58.0799Z"
          fill="currentColor"
          className="icon-primary"
        />
        <path
          opacity="0.4"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M29.397 10.25C30.832 10.25 31.9971 11.3925 31.9971 12.803C31.9971 14.2102 30.8354 15.3526 29.397 15.3526L23.8312 15.356C19.2119 15.3627 15.4536 19.0515 15.4536 23.5845V29.9369C15.4536 31.344 14.2851 32.4899 12.8501 32.4899C11.4151 32.4899 10.25 31.344 10.25 29.9369V23.5845C10.25 16.2405 16.3419 10.2601 23.8278 10.2534L29.3936 10.25H29.397ZM59.3472 10.25H53.9044C52.4694 10.25 51.3043 11.3925 51.3043 12.803C51.3043 14.2102 52.4694 15.3493 53.9044 15.3493H59.3472C63.9836 15.3493 67.7556 19.0481 67.7556 23.5946V29.9369C67.7556 31.344 68.9207 32.4899 70.3557 32.4899C71.7941 32.4899 72.9557 31.344 72.9557 29.9369V23.5946C72.9557 16.2338 66.8536 10.25 59.3472 10.25ZM29.3014 73.4917H23.8586C16.3522 73.4917 10.25 67.5079 10.25 60.1471L10.25 53.8048C10.25 52.3977 11.4117 51.2518 12.8501 51.2518C14.2851 51.2518 15.4502 52.3977 15.4502 53.8048L15.4502 60.1471C15.4502 64.6936 19.2222 68.3924 23.8586 68.3924H29.3014C30.7364 68.3924 31.9014 69.5315 31.9014 70.9387C31.9014 72.3492 30.7364 73.4917 29.3014 73.4917ZM53.8088 73.4917C52.3738 73.4917 51.2087 72.3492 51.2087 70.9387C51.2087 69.5315 52.3703 68.3891 53.8088 68.3891L59.3745 68.3857C63.9938 68.379 67.7522 64.6902 67.7522 60.1572L67.7522 53.8048C67.7522 52.3977 68.9207 51.2518 70.3557 51.2518C71.7907 51.2518 72.9558 52.3977 72.9558 53.8048V60.1572C72.9558 67.5012 66.8638 73.4816 59.3779 73.4883L53.8122 73.4917H53.8088Z"
          fill="currentColor"
          className="icon-secondary"
        />
      </svg>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};
